import React, { useEffect, useState } from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import "../i18n";
import { getAuth, onAuthStateChanged, signOut, User } from "firebase/auth";

// Components
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import Hero from "../Components/Hero/Hero";
import Auth from "../Components/Auth/Auth";
import ProjectsSection from "../Components/ProjectsSection/ProjectsSection";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./../Config/theme";

function App() {
  const { t } = useTranslation() as { t: (key: string) => string };
  const [user, setUser] = useState<User | null>(null);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, [auth]);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Header user={user} onSignOut={() => signOut(auth)} />
        <Hero />
        {user ? (
          <>
            <p>
              {t("welcome")} {user.displayName}!
            </p>
          </>
        ) : (
          <Auth />
        )}
        <ProjectsSection />
        <Footer user={user} /> {/* 👈 Always render Footer */}
      </div>
    </ThemeProvider>
  );
}
export default App;
